import { CREATE_ACCOUNT_MUTATION } from "@/apis/gql/apolloClient";
import type { AccountDetails } from "@/apis/gql/types";
import { useMutation } from "@apollo/client";
import { noop } from "lodash";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

type CreateAccount = {
  accountName: string;
  accountNo: string;
  accountDescription?: string;
};

export const useCreateAccount = () => {
  const { t } = useTranslation();
  const [createAccount, { data, loading, error }] = useMutation(
    CREATE_ACCOUNT_MUTATION,
  );

  const handleCreateAccount = (
    data: CreateAccount,
    onSuccess: (data: AccountDetails) => void = noop,
    onError: () => void = noop,
  ) => {
    toast.promise(createAccount({ variables: data }), {
      loading: t("generic_loading"),
      success: (createAccountResult) => {
        onSuccess(createAccountResult.data.createAccount);
        return t("generic_success");
      },
      error: () => {
        onError();
        return t("generic_error");
      },
    });
  };

  return { createAccount: handleCreateAccount, data, loading, error };
};
